const SUPPORTED_LOCALES = ['de', 'fr', 'it'] as const;

type SupportedLocale = (typeof SUPPORTED_LOCALES)[number];

export { SUPPORTED_LOCALES };
export type { SupportedLocale };
